import React from 'react';
import { useDrag } from 'react-dnd';
import { useDispatch } from 'react-redux';
import { ARTBOARD_CELL_ACCEPTED_DROP_TYPE } from 'components/ArtboardCell/useArtboardCellDropTarget';
import ComponentItem from 'components/ComponentItem';
import { IComponentItemOwnProps } from 'components/ComponentItem/models';
import { EntityType } from 'const';
import { toggleDragState } from 'containers/App/actions';
import { callToActionMapFactory } from 'factories/document/callToActionFactory';
import { AssetDragObject } from 'models';

const ElementItem: React.FC<IComponentItemOwnProps> = (props) => {
  const dispatch = useDispatch();
  const { size, type } = props;
  const dragSourceType = ARTBOARD_CELL_ACCEPTED_DROP_TYPE;
  const [{ isDragging }, dragRef] = useDrag<AssetDragObject, void, { isDragging: boolean }>({
    type: dragSourceType,
    item: () => {
      const component = callToActionMapFactory({ size });
      dispatch(toggleDragState(dragSourceType, type));

      return {
        component,
        type: type as EntityType,
      };
    },
    end: () => {
      dispatch(toggleDragState());
    },
    canDrag: () => true,
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return <ComponentItem {...props} connectDragSource={dragRef} isDragging={isDragging} />;
};

export default ElementItem;
